// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1tGXx","card":"style_card__28bh4","cardBody":"style_cardBody__54XYb","btn":"style_btn__2Ych-"};